//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
import WxjsSdk from "@/Manager/10.Tms/ProductSnManager";
import "@/assets/css/reset.css";
import "@/assets/css/global.css";

export default {
  components: { work_bench_item },
  data() {
    return {
      indexData: {},
      // work_bench_item1: [
      //   {
      //     img: "images/20_03.png",
      //     text: "新客会员列表",
      //     link: "/mGms/NewCustomerActivity"
      //   },
      // ],
      work_bench_item2: [
        {
          img: "images/20_07.png",
          text: "会员参与情况",
          // link: "/mMis/PrizeStockOutJoinOrder"
          link: this.$api.host + "/mMis/PrizeStockOutJoinOrder/Index"
        },
        {
          img: "images/2_06.png",
          text: "优惠券核销记录",
          // link: "/mGms/MemberCouponOrder"
          link: this.$api.host + "/mMis/MemberCouponOrder/Index"
        }
      ],
      work_bench_item3: [
        {
          img: "images/20_14.png",
          text: "产品积分核销",
          // link: "/mSms/PrizeStockOutProductOrder"
          link: this.$api.host + "/mSms/PrizeStockOutProductOrder/Index"
        },
        {
          img: "images/2_06.png",
          text: "积分兑换记录",
          // link: "/mSms/MemberPointsOutExchangeOrder"
          link: this.$api.host + "/mSms/MemberPointsOutExchangeOrder/Index"
        },
        {
          img: "images/2_06.png",
          text: "积分兑换记录(门店自提)",
          // link: "/mSms/MemberPointsOutExchangeOrderForShop"
          link:
            this.$api.host + "/mSms/MemberPointsOutExchangeOrderForShop/Index"
        },
        {
          img: "images/2_10.png",
          text: "门店自提扫码",
          // link: "/mSms/MemberCouponOrderPiao"
          // link: this.$api.host+"/mMms/MemberCouponOrder/Index"
          action: "scanQr"
        },
        {
          img: "images/1_19.png",
          text: "兑换补货出库单",
          // link: "/mSms/DealerStockOutExchangeOrder"
          link: this.$api.host + "/mSms/DealerStockOutExchangeOrder"
        },
        {
          img: "images/20_03.png",
          text: "新客活动列表",
          link: "/mGms/NewCustomerActivity"
        },
      ]
    };
  },
  computed: {},

  async onLoad() {},

  created() {
    this.wxJsSdk();
  },

  methods: {
    // 获取jssdk
    wxJsSdk() {
      console.log(location.href, "location.origin");
      var sdkData = {
        uOpenId: "8659662804444e4b9ff929bb78b3da21",
        url: location.href
      };
      WxjsSdk.wxJsSdk(sdkData).then(res => {
        this.$msg.hideLoading();
        wx.config({
          debug: false, // true,// 开启调试模式
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          // 必填，需要使用的JS接口列表
          jsApiList: ["scanQRCode"]
        });
      });
    },
    scanQr() {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
        success: res1 => {
          console.log("开始扫码", res1);
        },
        fail: err => this.err_toast(err)
      });
    }
  }
};
